import type { HttpClient } from '@/lib/http/client.js'
import type { TranslationCoverage, TranslationHealth } from '@/types/translation/translation.type.js'

/**
 * `admin/translations/*`, verified against `translation-admin.controller.ts`.
 *
 * Both routes REQUIRE a shop: an operator arrives with one merchant's complaint, and a
 * route that defaulted to "all shops" would scan the installed base to answer it.
 */
export interface TranslationService {
  coverage: (shopId: string) => Promise<readonly TranslationCoverage[]>
  health: (shopId: string) => Promise<TranslationHealth>
}

export function createTranslationService(http: HttpClient): TranslationService {
  return {
    coverage: (shopId) => http.get<readonly TranslationCoverage[]>('admin/translations/coverage', { query: { shop_id: shopId } }),
    health: (shopId) => http.get<TranslationHealth>('admin/translations/health', { query: { shop_id: shopId } }),
  }
}
